import { useLocation, useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useCallback } from 'react';

export function useRefreshAccessToken(writeLogToConsole = false) {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const navigate = useNavigate();
  return useCallback(() => {
    if (authState?.isAuthenticated) {
      const tokenTimestamp = Date.now();
      const timestamp = sessionStorage.getItem('tokenTimestamp');
      const savedTokenTimestamp = timestamp ? +timestamp : 0;
      const tokenRefreshNeeded = tokenTimestamp - savedTokenTimestamp > 5000;
      if (tokenRefreshNeeded) {
        sessionStorage.setItem('tokenTimestamp', tokenTimestamp.toString());
        if (writeLogToConsole)
          // eslint-disable-next-line no-console
          console.log('access token refresh is kicking in...');
        return oktaAuth.token.renewTokens().then(
          (tokens) => {
            return new Promise<boolean>((resolve) => {
              oktaAuth.tokenManager.setTokens(tokens, () => resolve(true));
              if (writeLogToConsole)
                // eslint-disable-next-line no-console
                console.log(
                  'tokens have been refreshed through refresh_token grand type'
                );
            });
          },
          (err) => {
            if (writeLogToConsole)
              // eslint-disable-next-line no-console
              console.log(
                err,
                'failed to refresh access token through refresh_token grand type, trying authorization_code now...'
              );
            return oktaAuth.token.getWithoutPrompt().then(
              (tokenResponse) => {
                return new Promise<boolean>((resolve) => {
                  const tokens = tokenResponse.tokens;
                  oktaAuth.tokenManager.setTokens(tokens, () => resolve(true));
                  if (writeLogToConsole)
                    // eslint-disable-next-line no-console
                    console.log(
                      'tokens have been refreshed through authorization_code grand type'
                    );
                });
              },
              (err) => {
                if (writeLogToConsole) {
                  // eslint-disable-next-line no-console
                  console.log(
                    err,
                    'failed to refresh access token through authorization_code grand type'
                  );
                  // eslint-disable-next-line no-console
                  console.log('logging out from the application...');
                }
                oktaAuth.tokenManager.clear();
                if (authState) {
                  authState.isAuthenticated = false;
                }
                navigate('/login', { state: { from: location } });
                return false;
              }
            );
          }
        );
      } else {
        if (writeLogToConsole)
          // eslint-disable-next-line no-console
          console.log(
            "access token refresh is happening in a parallel process, let's just wait here..."
          );
        return new Promise<boolean>((resolve) => {
          setTimeout(() => resolve(true), 3000);
        });
      }
    } else {
      // eslint-disable-next-line no-console
      if (writeLogToConsole) console.log('user is not logged in');
      navigate('/login', { state: { from: location } });
      return Promise.resolve(false);
    }
  }, [authState, oktaAuth, location, navigate, writeLogToConsole]);
}
